// copied from VPC, edited

import { DataGrid } from '@tableau/widgets-datagrid';
import * as React from 'react';
import { connect } from 'react-redux';

import { AppState } from '../../../../app/state/AppState';
import { Formatters, Messages } from '../../../../../gen-src/Localize';
import { L10n } from '../../../../common/utils/L10n';
import * as MetricsSelectors from '../../../selectors/selectMetrics';
import { Workbook } from '../../../models/SearchResultTypes';
import { DataPointsApiResponse } from '@tableau/metrics-engine';

export interface MetricUpdatedCellStateProps {
  readonly metricData?: DataPointsApiResponse;
  readonly isSuspended: boolean;
}

export interface MetricUpdatedCellOwnProps {
  readonly row: DataGrid.Row;
}

export type MetricUpdatedCellProps = MetricUpdatedCellOwnProps & MetricUpdatedCellStateProps;

export class MetricUpdatedCell extends React.PureComponent<MetricUpdatedCellProps> {
  public render() {
    const dateTime = this.props.metricData && this.props.metricData.dataRefreshedTimestamp;
    const updatedTime = dateTime ? new Date(dateTime) : undefined;
    const isMetricSuspended = this.props.isSuspended;
    let text: string;
    if (isMetricSuspended) {
      text = Messages.metricSuspendedRefreshTimestampPlaceholder();
    } else if (updatedTime) {
      text = Formatters.formatLongBestFitRelativeTime(updatedTime);
    } else {
      text = '—';
    }

    const testId = this.props.row.data ? `metric-updated-cell-${this.props.row.data.id}` : 'metric-updated-cell';

    return (
      <span style={{ display: 'flex' }} data-tb-test-id={testId}>
        <span style={textStyle} title={dateTime && !this.props.isSuspended ? L10n.localizedDateTime(updatedTime) : ''}>
          {text}
        </span>
      </span>
    );
  }
}

const textStyle: React.CSSProperties = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  padding: '0 12px',
  display: 'flex',
  flexGrow: 1,
  flexDirection: 'row',
  alignItems: 'left',
  justifyContent: 'left',
};

const mapStateToProps = (state: AppState, ownProps: MetricUpdatedCellOwnProps) => {
  const metricData = ownProps.row.data ? MetricsSelectors.selectMetricDataForContentItem(state, ownProps.row.data as Workbook) : undefined;
  const isSuspended = ownProps.row.data ? ownProps.row.data.suspended : false;

  return { metricData, isSuspended };
};

export const ConnectedMetricUpdatedCell = connect(mapStateToProps)(MetricUpdatedCell);
